module.exports = __webpack_public_path__ + "static/media/botte.24ec3a79.m4a";